import { TFunction } from 'i18next';
import { ControllerRenderProps, FieldValues } from 'react-hook-form';
import { DateFieldKey } from './field-keys';

export type Row = {
	key?: string;
	currentValues?: unknown[];
	value?: unknown;
	locationSignature?: string;
};

export const INPUT_TYPES = [
	'price',
	'text',
	'date',
	'boolean',
	'multi-select',
	'location',
] as const;

export type InputType = (typeof INPUT_TYPES)[number];

export type FieldOption = {
	name: string;
	inputType: InputType;
};

export type MultiUpdateRow = {
	key: string;
	value: string | number | boolean | string[];
	currentValues: Primitive[];
	locationSignature?: string;
};

export type MultiUpdateFormValues = {
	rows: MultiUpdateRow[];
};

type RHFStringField = ControllerRenderProps<FieldValues, string>;

export type InputRenderProps = {
	field: RHFStringField;
	t: TFunction;
	currencyCode?: string;
	watchedField?: string;
	id?: string;
};

// Baselines(current values) coming from queries (server), keyed by date field
export type Baselines = Partial<Record<DateFieldKey, string[]>>;

export type AddressLike = {
	countryCode?: string;
	postalCode?: string;
	city?: string;
	street?: string;
	houseNumber?: string | number;
};

export type Carrier = { id: number | string; name: string };

/** Primitive value we store in rows[i].currentValues */
export type Primitive = string | number | boolean;

export type fixedPriceOptionsType = {
	id: string;
	value: boolean;
	label: string;
}[];
